import {
  IGroupImportEnrolledStudent,
  IGroupImportResult,
} from "ts/interfaces/Group"

export const studentName = (student: IGroupImportEnrolledStudent) => {
  const name =
    [student.first_name, student.last_name].filter(Boolean).join(" ") ||
    `#${student.id}`
  const identifier = student.login || student.email
  return identifier ? `${name} (${identifier})` : name
}

export const isNothingToImport = (result: IGroupImportResult) =>
  result.imported === 0 && result.enrolled.length === 0

export const getSkippedRowsCount = (result: IGroupImportResult) =>
  result.invalid_rows.length + result.unmatched_rows.length
